module.exports = __webpack_public_path__ + "static/img/kf_cloud_00011.88cedc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00011.jpg
// module id = 182
// module chunks = 1